import { render, staticRenderFns } from "./Fax.vue?vue&type=template&id=4de4e8f0&scoped=true&"
import script from "./Fax.vue?vue&type=script&lang=js&"
export * from "./Fax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de4e8f0",
  null
  
)

export default component.exports